import * as React from "react";
import { clearAuthSession, redirectToAuth } from "../../shared/authService";
import "../styles/header.css";
import LogoutButton from "./LogoutButton";

type StatusTone = "ready" | "loading" | "analyzing" | "error";

interface HeaderProps {
  status: { text: string; tone: StatusTone };
}

const Header: React.FC<HeaderProps> = ({ status }) => {
  const statusClass =
    status.tone === "error"
      ? "header-status error"
      : status.tone === "loading"
      ? "header-status loading"
      : status.tone === "analyzing"
      ? "header-status analyzing"
      : "header-status";

  const handleLogout = () => {
    clearAuthSession();
    redirectToAuth();
  };

  return (
    <header className="header">
      <div className="header-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      </div>
      <div className="header-content">
        <h1 className="header-title">Lawyer On Board</h1>
        <p className="header-subtitle">Legal AI Assistant</p>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div className={statusClass}>
          <span className="status-dot" />
          <span>{status.text}</span>
        </div>
        <LogoutButton onClick={handleLogout} />
      </div>
    </header>
  );
};

export type { StatusTone };
export default Header;
